module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai648-f79cfa6744ba6a90590fd676f39d8ee7.jpg";